import React from 'react';
import './table.css';
import { Pagination } from '../Pagination';

function Footer({ data }) {
  const { page, pageChange, pageSizeChange, showDropDown, pageOptions = [15, 30, 50] } = data;
  return (
    <div className="flex items-center gap-2 mt-6">
      <Pagination
        pageSize={page.pageSize}
        pageSizeOptions={pageOptions}
        onPageSizeChange={(value) => {
          pageSizeChange(value);
        }}
        onPageChange={(page) => {
          pageChange(page);
        }}
        currentPage={page.pageNo}
        total={page.count}
        showSizeChanger={showDropDown}
      ></Pagination>
    </div>
  );
}
export default Footer;
